import { createApi } from 'effector';
import { $clientTeamMembers } from './states';

export const clientTeamMembersApi = createApi($clientTeamMembers, {
    remove: (store, payload: { userId: ID }) => {
        if (!store) {
            // Team members were not fetched yet
            return store;
        }

        // Filter team members
        const filteredTeamMembers = store.items.filter((member) => member.user.id !== payload.userId);

        return {
            ...store,
            items: filteredTeamMembers,
        };
    },
});
